module.exports = __webpack_public_path__ + "static/usfk-logo-939ea81403d8a4a7e65d919bce5ecc57.png";